module.exports = __webpack_public_path__ + "img/logo_suim.a376873d.png";